<template>
  <div class="wrap myoreders-wrap personal-wrap">
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <empty imgpath="/static/images/empty_invoice_3x.png" btnurl="/main/home" emptytext="您还没有发票信息" v-if="invoiceList.length==0 && !loadShow" btntext="去逛一逛"></empty>
    <div class=" flex-column flex-item orders-list detail" v-show="invoiceList.length!=0 && !loadShow">
      <div class="orders-list-item" v-for="invoiceListShow in invoiceList">
        <!-- v-for="listMsg in invoiceList" -->
        <div class="orders-list-item-title invoiceinfo-title">
          订单号：
          <label>{{invoiceListShow.orderId}}</label><span class="fr">{{invoiceListShow.orderTime}}</span>
        </div>
        <mu-list style="border-bottom: 1px solid #e5e5e5;">
          <myOrdersItem :width="150" :height="150" v-for="(goodsShow,invoiceIndex) in invoiceListShow.goodsOrderMsgs" :cartitem="goodsShow" :isRightTriggle="'true'" :key="invoiceIndex">
          </myOrdersItem>
        </mu-list>
        <div class="orders-list-item-state">
          <p>发票信息</p>
          <div class="state">
            发票类型：<span class="black">{{invoiceListShow.invoiceData&&invoiceListShow.invoiceData.invoiceTypeName ||'无'}}</span>
            <br/> 发票内容：
            <span class="black">{{invoiceListShow.invoiceData&&invoiceListShow.invoiceData.invoiceContentName || '无'}}</span>
            <br/> 发票抬头：
            <span class="black">{{invoiceListShow.invoiceData&&invoiceListShow.invoiceData.invoiceHead || '无'}}</span>
          </div>
        </div>
      </div>
      <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
      <p class="none-goods" v-if="(lastPageNo == currentPage && !loadShow) || (total ==0 && !loadShow) ">没有更多信息啦~</p>
    </div>
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import empty from '@components/empty/empty';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      loadShow: true,
      loading: false,
      scroller: null,
      pageNo: 1,
      pageSize: 10,
      total: 0,//z总数量
      currentPage:0,
      lastPageNo:1,//总共页面数量
      invoiceList: [],
    }
  },
  methods: {
    ...mapActions({
      pageMemOrderInvoice: 'pageMemOrderInvoice', //获取发票信息
    }),
    // 加载更多
    loadMore() { 
      if(this.lastPageNo == this.pageNo){
        this.loading = false;
      }else{
        this.loading = true;
        this.pageNo ++ ;
        this.getpageMemOrderInvoice();
        setTimeout(() => { 
          this.loading = false
        }, 2000)
      }
    },
    getpageMemOrderInvoice(){
      this.pageMemOrderInvoice([this.pageNo, this.pageSize]).then(res => {
        this.loadShow = false;
        let _this =this;
        res.result.forEach(item => {
           _this.invoiceList.push(item)
        })
        // this.invoiceList = res.result;
        this.lastPageNo = Number(res.lastPageNo);
        this.currentPage = Number(res.currentPageNo);
        this.total = Number(res.totalCount);
      }).catch(error => {
        console.log(error)
        // this.$message.error(error);
      })
    }
  },
  watch: {},
  mounted() {
    this.scroller = document.querySelectorAll('.orders-list')[0];
    console.log( this.scroller)
    this.getpageMemOrderInvoice();
  },
  components: {
    menus,
    myOrdersItem,
    empty
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.myoreders-wrap {
  .orders-list.detail {
    .orders-list-item {
      margin-top: 0.2rem;
      .orders-list-item-title.invoiceinfo-title {
        @include font-dpr(14px);
        color: #999999;
        label {
          color: #000000;
        }
        span {
          @include font-dpr(12px);
        }
      }
      .orders-list-item-state {
        p {
          @include font-dpr(14px);
          padding: 0.2rem 0;
          color: #666;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// invoiceinfo.vue?51344829